import React from "react";
// import { toast } from 'react-toastify';
import useAPI from "../../hooks/useAPI";
import toast from 'react-hot-toast';
import { icon } from "@fortawesome/fontawesome-svg-core";
import { FaCheck, FaExclamationTriangle, FaInfo, FaTimes } from "react-icons/fa";
import { maxWidth, width } from "@mui/system";

// Mapa de tipos de toast
const toastType = {
    "success": toast.success,
    "warning": toast.warning,
    "info": toast.info,
    "error": toast.error,
};

export const sendToast = (e) => {
    const dark = localStorage.getItem("IS_DARK");
    toast.dismiss()

    let time = e.time || 5000;

    const iconMap = {
        info: {
            bg: '#08e3ff',
            icon: <FaInfo size={12} color="#ffffff" />,
        },
        warning: {
            bg: '#ffe733',
            icon: <FaExclamationTriangle size={12} color="#000000" />,
        },
        success: {
            bg: '#1aeb72',
            icon: <FaCheck size={12} color="#ffffff" />,
        },
        error: {
            bg: '#ff4d4f',
            icon: <FaTimes size={12} color="#ffffff" />,
        },
    };

    const current = iconMap[e.type];

    const obj = {
        icon: current ? (
            <div className="d-flex justify-content-center" style={{width: '10%'}}>
                <span id="span-icon-toast" style={{backgroundColor: current.bg}}>
                    {current.icon}
                </span>
            </div>
        ) : null,
        // duration: Infinity,
        duration: time,
        position: 'top-center',
        style: {
            background: "#ffffff",
            fontWeight: 'bold'
        },
        className: '',
        iconTheme: {
            primary: e.type == 'success' ? '#1aeb72' : e.type == 'warning' ? '#ffe733' : e.type == 'error' ? '#ff8585' : '#08e3ff',
            secondary: dark === 'true' ? '#000000' : '#ffffff',
        },
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
        removeDelay: 500,
        theme: "light",
        className: "custom-toast-container",
        bodyClassName: "custom-toast-body",
    }

    let msj = e.message || "Ocurrió un error inesperado.";
    
    if (e.strong) {
        msj = msj.replace(/\*/g, "<strong>").replace(/\+/g, "</strong>");
    } 

    // Aplicar negrita solo si `e.strong` está activo
    const FormattedMessage = () => <div dangerouslySetInnerHTML={{ __html: msj }} />;

    const iconKey = (e.type || "").toString().trim().toLowerCase();
    const showToast = toastType[iconKey] || toast;
    
    // Validamos que `showToast` no sea `undefined` antes de llamarlo
    if (typeof showToast === "function") {
        showToast(<FormattedMessage />, obj);
    } else {
        console.error(`Tipo de toast inválido: "${iconKey}"`);
    }
}

// Mostrar modal que notifica estados como success, info, warning, etc
export const sendToast_back = (data) => {
    toast.dismiss();

    let time = data.time || 5000;

    const obj = {
        position: "top-center",
        autoClose: time,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        className: "custom-toast-container",
        bodyClassName: "custom-toast-body",
    }

    let msj = data.message || "Ocurrió un error inesperado.";
    
    if (data.strong) {
        msj = msj.replace(/\*/g, "<strong>").replace(/\+/g, "</strong>");
    } 

    // Aplicar negrita solo si `data.strong` está activo
    const FormattedMessage = () => <div dangerouslySetInnerHTML={{ __html: msj }} />;

     const showToast = toastType[data.type] || toast.error;
    
    // Validamos que `showToast` no sea `undefined` antes de llamarlo
    if (typeof showToast === "function") {
        showToast(<FormattedMessage />, obj);
    } else {
        console.error(`Tipo de toast inválido: "${data.type}"`);
    }
}

export const questionToast = (data, setLoading) => {
    return new Promise((resolve, reject) => {
        toast.dismiss();
        const { isFetch, fetch, title, text, icon, buttons } = data;
        
        // const SplitButtons = ({closeToast}) => {
        const SplitButtons = () => {
            
            const { fetchWithAuth } = useAPI();
            
            const handleReloadClick = async () => {
                try{
                    if (isFetch) {
                        setLoading(true)
                        const { url, options } = fetch;
                        
                        const response = await fetchWithAuth(url, options);
                        const result = await response.json();
                        // closeToast(false);
                        toast.dismiss()
                        resolve(result)
                    } else {
                        // closeToast(false);
                        toast.dismiss()
                        resolve(true)
                    }
                }catch(error){
                    setLoading(false);
                } finally {
                    setLoading(false);
                };
            };
        
            return (
                <div className="grid grid-cols-[1fr_1px_80px] w-full">
                    <div className="flex flex-col py-4 px-2">
                        <h3 className="text-zinc-800 text-sm font-semibold">{title}</h3>
                        <p className="text-sm" style={{whiteSpace: "break-spaces"}}>{text}</p>
                    </div>
                    <div className="bg-zinc-900/20 h-full" />
                    <div className="d-flex justify-content-evenly mt-1 pt-1">
                        {buttons.cancel && (
                            <a
                            href="javascript:;"
                            className="btn btn-lg btn-default mr-1"
                            // onClick={() => closeToast(false)}
                            onClick={() => toast.dismiss()}
                            >
                                {buttons.cancel}
                            </a>

                        )}
                        {buttons.success && (
                            <input
                                className="btn btn-lg btn-info"
                                value={buttons.success}
                                type="button"
                                onClick={handleReloadClick}
                            />
                        )}
                    </div>
                </div>
            );
        };

        const iconKey = (data.icon || "").toString().trim().toLowerCase();
        const toastFunc = toastType[iconKey] || toast;
        const isIconType = ['info', 'warning'].includes(data.icon);
        

        toastFunc(
            <SplitButtons />,
            {
                icon: isIconType ? (
                    <div style={{width: '30%'}}>
                        <span
                            style={{
                                backgroundColor: data.icon === 'info' ? '#08e3ff' : '#ffe733',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '30px',
                                height: '30px',
                            }}
                        >
                            {data.icon === 'info' ? (
                                <FaInfo size={20} color="#ffffff" />
                            ) : (
                                <FaExclamationTriangle size={20} color="#000000" />
                            )}
                        </span>
                    </div>
                ) : null,
                position: "top-center",
                duration: Infinity,
                style: {
                    background: '#fff',
                    color: '#333',
                    maxWidth: '430px'
                },
                className: "custom-toast-container",
                ariaProps: {
                    role: 'status',
                    'aria-live': 'polite',
                }
            }
        );
    });
};

// {
//     position: "top-center",
//     duration: Infinity,
//     autoClose: false,
//     hideProgressBar: false,
//     closeOnClick: false,
//     pauseOnHover: true,
//     draggable: false,
//     theme: "light",
//     className: "custom-toast-container",
//     bodyClassName: "custom-toast-body",
// }